// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"LoadingSpinner_loadingSpinner__EZeJo","spinner":"LoadingSpinner_spinner__eOMKC","spin":"LoadingSpinner_spin__Sg2Se"};